import React from "react";
import { useTranslation } from "react-i18next";
import "./styles/Services.css";
import TitleFragment from "./TitleFragment";
import SEO from "./SEO";

function QtCodeQualityAnalysis() {
    const { t } = useTranslation();

    return (
        <div className="service-page">
            <SEO
                title={t('qtcode.seoTitle')}
                description={t('qtcode.seoDescription')}
                keywords={t('qtcode.seoKeywords')}
                url="/qt-code-quality-analysis"
                schemaType="service"
            />
            <TitleFragment title={t('qtcode.pageTitle')} />

            <div className="service-container">
                <p className="service-intro-text" style={{ textAlign: 'center', fontSize: '1.4rem', fontWeight: '500', marginTop: '2rem', marginBottom: '1rem' }}>
                    {t('qtcode.intro1')}
                </p>

                <section className="service-section">
                    <p className="service-intro-text">
                        {t('qtcode.intro2')}
                    </p>
                </section>

                <section className="service-section">
                    <h2>{t('qtcode.whyItMatters')}</h2>
                    <div className="service-card-grid">
                        <div className="service-card">
                            <h3>{t('qtcode.reduceTechDebt')}</h3>
                            <p>{t('qtcode.reduceTechDebtDesc')}</p>
                        </div>
                        <div className="service-card">
                            <h3>{t('qtcode.improveReliability')}</h3>
                            <p>{t('qtcode.improveReliabilityDesc')}</p>
                        </div>
                        <div className="service-card">
                            <h3>{t('qtcode.enhancePerformance')}</h3>
                            <p>{t('qtcode.enhancePerformanceDesc')}</p>
                        </div>
                        <div className="service-card">
                            <h3>{t('qtcode.ensureScalability')}</h3>
                            <p>{t('qtcode.ensureScalabilityDesc')}</p>
                        </div>
                    </div>
                </section>

                <section className="service-section">
                    <h2>{t('qtcode.ourApproach')}</h2>
                    <div className="service-card-grid">
                        <div className="service-card">
                            <h4>{t('qtcode.step1Title')}</h4>
                            <p>{t('qtcode.step1Desc')}</p>
                            <ul>
                                <li>{t('qtcode.step1Item1')}</li>
                                <li>{t('qtcode.step1Item2')}</li>
                                <li>{t('qtcode.step1Item3')}</li>
                                <li>{t('qtcode.step1Item4')}</li>
                            </ul>
                        </div>
                        <div className="service-card">
                            <h4>{t('qtcode.step2Title')}</h4>
                            <p>{t('qtcode.step2Desc')}</p>
                            <ul>
                                <li>{t('qtcode.step2Item1')}</li>
                                <li>{t('qtcode.step2Item2')}</li>
                                <li>{t('qtcode.step2Item3')}</li>
                            </ul>
                        </div>
                        <div className="service-card">
                            <h4>{t('qtcode.step3Title')}</h4>
                            <p>{t('qtcode.step3Desc')}</p>
                            <ul>
                                <li>{t('qtcode.step3Item1')}</li>
                                <li>{t('qtcode.step3Item2')}</li>
                                <li>{t('qtcode.step3Item3')}</li>
                            </ul>
                        </div>
                        <div className="service-card">
                            <h4>{t('qtcode.step4Title')}</h4>
                            <p>{t('qtcode.step4Desc')}</p>
                            <ul>
                                <li>{t('qtcode.step4Item1')}</li>
                                <li>{t('qtcode.step4Item2')}</li>
                                <li>{t('qtcode.step4Item3')}</li>
                            </ul>
                        </div>
                        <div className="service-card">
                            <h4>{t('qtcode.step5Title')}</h4>
                            <p>{t('qtcode.step5Desc')}</p>
                            <ul>
                                <li>{t('qtcode.step5Item1')}</li>
                                <li>{t('qtcode.step5Item2')}</li>
                                <li>{t('qtcode.step5Item3')}</li>
                            </ul>
                        </div>
                    </div>
                </section>

                <section className="service-section">
                    <h2>{t('qtcode.empowerTeam')}</h2>
                    <p className="service-intro-text">
                        {t('qtcode.empowerTeamDesc')}
                    </p>
                </section>
            </div>
        </div>
    );
}

export default QtCodeQualityAnalysis;
